import { render, staticRenderFns } from "./ImageSimilarity.vue?vue&type=template&id=32c297a0&scoped=true"
import script from "./ImageSimilarity.vue?vue&type=script&lang=js"
export * from "./ImageSimilarity.vue?vue&type=script&lang=js"
import style0 from "./ImageSimilarity.vue?vue&type=style&index=0&id=32c297a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c297a0",
  null
  
)

export default component.exports